import React from 'react';
import { Text, Link } from '@chakra-ui/react';
import CookieConsent from 'react-cookie-consent';

const HoverCookieConsent = () => (
  <CookieConsent
    location="bottom"
    buttonText="Accept All Cookies"
    cookieName="HOVER cookie consent"
    style={{
      left: '50%',
      transform: 'translate(-50%, 0)',
      background: 'rgba(249,250,255)',
      border: 'solid 1px rgb(241, 241, 241)',
      color: 'rgb(25, 30, 35)',
      maxWidth: 875,
      margin: 'auto',
      borderRadius: 3,
      alignItems: 'center',
      padding: '5px 10px',
    }}
    buttonStyle={{
      border: '2px solid #d3e6fa',
      fontWeight: 'bold',
      backgroundColor: 'white',
      borderRadius: '8px',
      minHeight: 60,
    }}
  >
    <Text>
      We use cookies to provide visitors with a great user experience. By using
      HOVER, you accept our <Link href="/cookie-policy/">Cookie Policy</Link>{' '}
      and <Link href="/privacy/">Privacy Policy</Link>.
    </Text>
  </CookieConsent>
);

export default HoverCookieConsent;
